@if (showNotificationList()) {
<mat-card-header style="display: block;    padding: 0px 16px 0;">
    <div style="    display: flex;
    justify-content: end;">
        <button matButton="filled" mat-raised-button color="primary" (click)="onNewApplication()" class="cp-btn-submit">
            <mat-icon> add</mat-icon> Add</button>
    </div>
</mat-card-header>
<mat-card-content style="padding-bottom: 0px !important;">
    <div class="mat-elevation-z8" style="box-shadow: none;" class="table-container">

        <table mat-table [dataSource]="dataSourceUI" multiTemplateDataRows>

            @if (isMobile) {
            <ng-container matColumnDef="Title">
                <th mat-header-cell *matHeaderCellDef class="sticky-header"> Title </th>
                <td mat-cell *matCellDef="let row" [matTooltip]="row.Message"> {{ textTruncate(row.Title,15) }}
                </td>
            </ng-container>
            <ng-container matColumnDef="Placement">
                <th mat-header-cell *matHeaderCellDef class="sticky-header"> Placement </th>
                <td mat-cell *matCellDef="let row"> {{row.Placement}}
                </td>
            </ng-container>
            }
            @else{
            <ng-container matColumnDef="Title">
                <th mat-header-cell *matHeaderCellDef class="sticky-header"> Title </th>
                <td mat-cell *matCellDef="let row" [matTooltip]="row.Message"> {{ textTruncate(row.Title,15) }}
                </td>
            </ng-container>
            <ng-container matColumnDef="Audience">
                <th mat-header-cell *matHeaderCellDef class="sticky-header"> Audience </th>
                <td mat-cell *matCellDef="let row"> {{ row.Audience === notificationAudienceEnum.all ? 'All' :
                    row.Audience }}
                </td>
            </ng-container>
            <ng-container matColumnDef="Placement">
                <th mat-header-cell *matHeaderCellDef class="sticky-header"> Placement </th>
                <td mat-cell *matCellDef="let row"> {{row.Placement}}
                </td>
            </ng-container>
            <ng-container matColumnDef="StartTime">
                <th mat-header-cell *matHeaderCellDef class="sticky-header"> Start Time </th>
                <td mat-cell *matCellDef="let row"> {{ row.StartAt | date:'short' }}
                </td>
            </ng-container>
            <ng-container matColumnDef="EndTime">
                <th mat-header-cell *matHeaderCellDef class="sticky-header"> End Time </th>
                <td mat-cell *matCellDef="let row"> {{ row.EndAt | date:'short' }}
                </td>
            </ng-container>
            }
            <ng-container matColumnDef="Edit">
                <th mat-header-cell *matHeaderCellDef class="sticky-header"> Action </th>
                <td mat-cell *matCellDef="let row" class="tb-item-center">
                    <button mat-icon-button class="clickable toggle-btn" (click)="onEditClick(row)">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <mat-slide-toggle color="primary" [checked]="row.IsActive"
                        (change)="onStatusToggleChange($event,row)"></mat-slide-toggle>
                    <button mat-icon-button class="clickable toggle-btn" (click)="openDialog(row)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <!-- <ng-container matColumnDef="Delete">
                <th mat-header-cell *matHeaderCellDef class="sticky-header"> Delete </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button class="clickable toggle-btn">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container> -->

            <!-- HEADER for leaf rows only -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

            <!-- LEVEL 1 GROUP ROW: references the 'group-app' column -->
            <!-- <tr mat-row *matRowDef="let row; columns: ['group-app']; when: isLevel1"></tr> -->

            <!-- LEVEL 2 GROUP ROW: references the 'group-type' column -->
            <!-- <tr mat-row *matRowDef="let row; columns: ['group-type']; when: isLevel2"></tr> -->

            <!-- LEAF ROW: references the leaf columns -->
            <tr mat-row *matRowDef=" let row; columns:
        displayedColumns; when: isLeafRow" class="leaf-row"></tr>

        </table>

    </div>
</mat-card-content>
}
@else {
<app-add-edit-notification [notification]="notification" (onCancelClick)="onCancelHandel($event)"
    (onDataRefresh)="onDataRefresh($event)"></app-add-edit-notification>
}